import api from './api';
import * as consts from '../../utils/constants/url';

const authApi = api.injectEndpoints({
  endpoints: build => ({
    getUser: build.query({
      query: () => consts.API_AUTH_USER,
      forceRefetch: () => true,
    }),
    login: build.mutation({
      query({password, username}) {
        return {
          url: consts.API_AUTH_LOGIN,
          method: 'POST',
          body: {password, username},
        };
      },
      transformErrorResponse: response => ({
        status: response.status,
        errors: response.data.errors,
      }),
    }),
    logout: build.query({
      query: () => consts.API_AUTH_LOGOUT,
    }),
  }),
});

export const {useGetUserQuery, useLoginMutation, useLazyLogoutQuery} = authApi;

export default authApi;
